module.exports = __webpack_public_path__ + "static/media/a-new-hope-thumb.e9d83296.png";